module.exports = __webpack_public_path__ + "img/dengji8.774449ae.png";